// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#add-lab-user-account .el-form-item__content .el-input-group[data-v-1bfb622c] {\n  vertical-align: initial;\n}", ""]);
// Exports
module.exports = exports;
